export const ASYNC_TASK_TYPES = {
  statementsExport: 'statementsExport',
  getStatementsTask: 'getStatementsTask',
  quickBooksUpdateMetrics: 'quickBooksUpdateMetrics',
  plaidUpdateMetrics: 'plaidUpdateMetrics',
  xeroUpdateMetrics: 'xeroUpdateMetrics',
};
